export const CLM_FREE_DATA = 'CLM_FREE_DATA'

export const CLM_SET_CLAIMS_LOADING_STATE = 'CLM_SET_CLAIMS_LOADING_STATE'

export const CLM_CLEAR_CLAIMS_LIST = 'CLM_CLEAR_CLAIMS_LIST' // Очистка списка запросов на КП
export const CLM_GET_CLAIMS_LIST = 'CLM_GET_CLAIMS_LIST' // Получение списка запросов на КП, согласно установленному текущему фильтру

export const CLM_POST_CLAIM = 'CLM_POST_CLAIM' // Изменение состояния запроса
export const CLM_ADD_FILE = 'CLM_ADD_FILE' // Добавление файла к запросу
export const CLM_DEL_FILE = 'CLM_DEL_FILE' // Удаление файла из запроса
export const CLM_CHANGE_COMMENT = 'CLM_CHANGE_COMMENT' // Добавление/обновление комментария
export const CLM_DELETE_COMMENT = 'CLM_DELETE_COMMENT' // Удаление комментария

export const CLM_SET_CLAIMS_FILTER = 'CLM_SET_CLAIMS_FILTER' // Установка фильтра на список обращений
export const CLM_GET_CLAIM_STATUS_LIST = 'CLM_GET_CLAIM_STATUS_LIST'
export const CLM_GET_CLAIM_TYPES_LIST = 'CLM_GET_CLAIM_TYPES_LIST'
export const CLM_SET_CURRENT_CLAIM = 'CLM_SET_CURRENT_CLAIM'
export const CLM_CREATE_CLAIM = 'CLM_CREATE_CLAIM' // Создание нового обращения
export const CLM_CANCEL_CLAIM = 'CLM_CANCEL_CLAIM' // Отмена обращения

export const CLM_DATA_LONGPOLL = 'CLM_DATA_LONGPOLL'
export const CLM_READ_CLAIM = 'CLM_READ_CLAIM'
